enum ActionListControlEnum {
	checkbox = 'Checkbox',
	chevron = 'Chevron',
	radioButton = 'RadioButton',
	switch = 'Switch'
}

export default ActionListControlEnum;
